import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import React, { useMemo, useState } from 'react'
import { Box, Button, Modal } from 'uikit'
import ModalActions from 'components/ModalActions'
import Balance from 'components/Balance'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { useResponsive } from '../../../hooks/useResponse'
import { useTranslation } from 'react-i18next'

const BalanceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`

interface DepositModalProps {
  earnings: BigNumber
  onConfirm: (amount: string, decimals: number) => void
  onDismiss: () => void
  tokenName?: string
  stakingTokenDecimals?: number
}

const CompoundModal: React.FC<DepositModalProps> = ({
  earnings,
  onConfirm,
  onDismiss,
  tokenName = '',
  stakingTokenDecimals = 18,
}) => {
  const { isMobile } = useResponsive()
  const [pendingTx, setPendingTx] = useState(false)
  const { t } = useTranslation()
  const fullBalance = useMemo(() => {
    return getFullDisplayBalance(earnings, stakingTokenDecimals)
  }, [earnings, stakingTokenDecimals])

  return (
    <Modal
      style={{ width: isMobile ? '96%' : '440px' }}
      title={`${t('POOL_31')} ${t('POOL_32', { tokenName })}`}
      onDismiss={onDismiss}
    >
      <BalanceRow>
        <Balance styles={{ fontWeight: 700 }} value={Number(fullBalance)} />
      </BalanceRow>
      <ModalActions>
        <Button width="100%" variant="secondary" onClick={onDismiss}>
          {t('POOL_33')}
        </Button>
        <Box style={{ width: '30px' }} />
        <Button
          id="compound-cake"
          width="100%"
          disabled={pendingTx}
          onClick={async () => {
            setPendingTx(true)
            await onConfirm(fullBalance, stakingTokenDecimals)
            setPendingTx(false)
            onDismiss()
          }}
        >
          {pendingTx ? t('POOL_34') : t('POOL_35')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default CompoundModal
